export default "__VITE_ASSET__CCrCaPfo__"